var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tabs)?_c('div',{staticClass:"full",class:{
        english:!_vm.isCn,
        gray_icon: _vm.$x.userInfo.grayIcon,
        ky_ios_app: _vm.isKayangIos || _vm.isIosX,
        is_android: _vm.isAndroid,
        showHead: _vm.showBar.head,
        showFoot: _vm.showBar.foot,
    }},[(_vm.showBar.head && _vm.tabs.length)?_c('head-bar'):_vm._e(),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"auto-bar app-container"}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"auto-bar app-container"}):_vm._e(),_vm._v(" "),(_vm.showBar.foot && _vm.tabs.length)?_c('foot-bar',{attrs:{"tabs":_vm.tabs}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }